import type React from 'react';
import { theme } from 'antd';

/**
 * Biến màu `--bk-*` cho các thẻ Bank (đợt 260922) — lấy từ token antd nên tự đổi theo công tắc sáng/tối có sẵn của
 * admin (`App.tsx` `darkAlgorithm`). Một chỗ cho cả thẻ nhân vật lẫn thẻ bối cảnh/đạo cụ.
 */
export function useBankVars(): React.CSSProperties {
  const { token } = theme.useToken();
  return {
    '--bk-bg': token.colorBgContainer,
    '--bk-fill': token.colorFillQuaternary,
    '--bk-pill': token.colorFillTertiary,
    '--bk-line': token.colorBorderSecondary,
    '--bk-text': token.colorText,
    '--bk-muted': token.colorTextSecondary,
    '--bk-dim': token.colorTextQuaternary,
    '--bk-ok': token.colorSuccess,
    '--bk-warn': token.colorWarning,
    '--bk-bad': token.colorError,
    '--bk-accent': token.colorPrimary,
  } as React.CSSProperties;
}
